export interface DeviceSeriesState {
  timestamps: number[];
  temperature: number[];
  humidity: number[];
  pressure: number[];
  co2: number[];
  tvoc: number[];
  radar: number[];
  rssi: number[];
  lqi: number[];
}

export interface ActiveDeviceRef {
  registryId: string | null;
  deviceId: string | null;
}

export interface DeviceState {
  activeDevice: ActiveDeviceRef;
  timeRange: number | null;
  dataType: string;
  deviceData: DeviceSeriesState;
  removeForceResponse?: any;
  responseOnDeviceInfo?: any;
  responseOnJoinState?: any;
  responseOnGatewayInfo?: any;
  responseOnDeviceSettings?: any;
  responseOnAlarmsHistory?: any;
  responseOnTelemetryHistory?: any;
  responseOnAlarmSeen?: any;
  responseOnAlarmDismissed?: any;
  responseOnReadBorderRouterData?: any;
  responseOnReadRoomSensorData?: any;
  responseOnAlarmsHistoryPerUser?: any;
}

export const initialDeviceSeriesState = (): DeviceSeriesState => ({
  timestamps: [],
  temperature: [],
  humidity: [],
  pressure: [],
  co2: [],
  tvoc: [],
  radar: [],
  rssi: [],
  lqi: [],
});

export const initialDeviceState = (): DeviceState => ({
  activeDevice: { registryId: null, deviceId: null },
  timeRange: null,
  dataType: "temperature",
  deviceData: initialDeviceSeriesState(),
});

export default {
  setActiveDevice(state: DeviceState, payload: ActiveDeviceRef) {
    state.activeDevice = payload;
  },
  setTimeRange(state: DeviceState, payload: number) {
    state.timeRange = payload;
  },
  setDataType(state: DeviceState, payload: string) {
    state.dataType = payload;
  },
  setData(state: DeviceState, payload: Array<{ timestamp: number; value: number }>) {
    state.deviceData = initialDeviceSeriesState();
    payload.forEach((sample) => {
      state.deviceData.timestamps.push(sample.timestamp);
      state.deviceData.temperature.push(sample.value);
      state.deviceData.humidity.push(sample.value);
      state.deviceData.pressure.push(sample.value);
      state.deviceData.co2.push(sample.value);
      state.deviceData.tvoc.push(sample.value);
      state.deviceData.radar.push(sample.value);
      state.deviceData.rssi.push(sample.value);
      state.deviceData.lqi.push(sample.value);
    });
  },
  setDataForType(state: DeviceState, payload: { type: string; data: Array<{ timestamp: number; value: number }> }) {
    state.deviceData = initialDeviceSeriesState();
    if (payload.type === 'temperature') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.temperature.push(sample.value);
      });
    } else if (payload.type === 'humidity') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.humidity.push(sample.value);
      });
    } else if (payload.type === 'pressure') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.pressure.push(sample.value);
      });
    } else if (payload.type === 'co2') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.co2.push(sample.value);
      });
    } else if (payload.type === 'tvoc') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.tvoc.push(sample.value);
      });
    } else if (payload.type === 'radar') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.radar.push(sample.value);
      });
    } else if (payload.type === 'rssi') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.rssi.push(sample.value);
      });
    } else if (payload.type === 'lqi') {
      payload.data.forEach((sample) => {
        state.deviceData.timestamps.push(sample.timestamp);
        state.deviceData.lqi.push(sample.value);
      });
    }
  },
  setSample(state: DeviceState, payload: { timestamp: number; temperature?: number; humidity?: number; pressure?: number; co2?: number; tvoc?: number; radar?: number; rssi?: number; lqi?: number; }) {
    state.deviceData.timestamps.push(payload.timestamp);
    state.deviceData.temperature.push(payload.temperature as number);
    state.deviceData.humidity.push(payload.humidity as number);
    state.deviceData.pressure.push(payload.pressure as number);
    state.deviceData.co2.push(payload.co2 as number);
    state.deviceData.tvoc.push(payload.tvoc as number);
    state.deviceData.radar.push(payload.radar as number);
    state.deviceData.rssi.push(payload.rssi as number);
    state.deviceData.lqi.push(payload.lqi as number);
  },
  resetData(state: DeviceState) {
    Object.assign(state, initialDeviceState());
  },
  setRemoveForceResponse(state: DeviceState, payload: any) {
    state.removeForceResponse = payload;
  },
  setResponseOnDeviceInfo(state: DeviceState, payload: any) {
    state.responseOnDeviceInfo = payload;
  },
  setResponseOnJoinState(state: DeviceState, payload: any) {
    state.responseOnJoinState = payload;
  },
  setResponseOnGatewayInfo(state: DeviceState, payload: any) {
    state.responseOnGatewayInfo = payload;
  },
  setResponseOnDeviceSettings(state: DeviceState, payload: any) {
    state.responseOnDeviceSettings = payload;
  },
  setResponseOnAlarmsHistory(state: DeviceState, payload: any) {
    state.responseOnAlarmsHistory = payload;
  },
  setResponseOnTelemetryHistory(state: DeviceState, payload: any) {
    state.responseOnTelemetryHistory = payload;
  },
  setResponseOnAlarmSeen(state: DeviceState, payload: any) {
    state.responseOnAlarmSeen = payload;
  },
  setResponseOnAlarmDismissed(state: DeviceState, payload: any) {
    state.responseOnAlarmDismissed = payload;
  },
  setResponseOnReadBorderRouterData(state: DeviceState, payload: any) {
    state.responseOnReadBorderRouterData = payload;
  },
  setResponseOnReadRoomSensorData(state: DeviceState, payload: any) {
    state.responseOnReadRoomSensorData = payload;
  },
  setResponseOnAlarmsHistoryPerUser(state: DeviceState, payload: any) {
    state.responseOnAlarmsHistoryPerUser = payload;
  },
};
